import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/shared";
import { LogIn, Lock } from "lucide-react";

const fmtErr = (d) => {
  if (d == null) return "Login failed. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
};

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email.trim(), password); }
    catch (err) { setError(fmtErr(err?.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="login-wrap" data-testid="login-page">
      <div className="login-card">
        <div className="login-brand"><Logo height={40} /></div>
        <div className="login-eyebrow">Underwriting Terminal</div>
        <h1 className="login-title">Sign in to XYZ Ventures</h1>
        <p className="login-sub">Private deal-underwriting workspace. Enter your credentials to continue.</p>
        <form onSubmit={submit} className="login-form">
          <label className="login-label">Email</label>
          <input className="inp" type="email" autoComplete="username" placeholder="you@xyzvtr.com" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          <label className="login-label" style={{ marginTop: 12 }}>Password</label>
          <div style={{ position: "relative" }}>
            <Lock size={14} style={{ position: "absolute", left: 10, top: 11, color: "var(--text3)" }} />
            <input className="inp" style={{ paddingLeft: 30 }} type="password" autoComplete="current-password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          </div>
          {error && <div className="login-error" data-testid="login-error">{error}</div>}
          <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: "100%", marginTop: 16, justifyContent: "center" }} data-testid="login-submit">
            <LogIn size={15} style={{ marginRight: 6 }} />{busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="login-foot">Access is restricted to authorized team members.</div>
      </div>
    </div>
  );
}
